import api from '@/services/api/localApi'

class ClientAppService {
  printLabel (artwork) {
    return api.post('printer', artwork)
  }
}

export default new ClientAppService()



// WEBPACK FOOTER //
// ./src/services/clientApp/ClientAppService.js